import { render, staticRenderFns } from "./my-uploadVideo.vue?vue&type=template&id=5fe1aead&scoped=true"
import script from "./my-uploadVideo.vue?vue&type=script&lang=js"
export * from "./my-uploadVideo.vue?vue&type=script&lang=js"
import style0 from "./my-uploadVideo.vue?vue&type=style&index=0&id=5fe1aead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe1aead",
  null
  
)

export default component.exports